import { render, staticRenderFns } from "./b2b-button.vue?vue&type=template&id=bb0c9866&scoped=true"
import script from "./b2b-button.vue?vue&type=script&lang=js"
export * from "./b2b-button.vue?vue&type=script&lang=js"
import style0 from "./b2b-button.vue?vue&type=style&index=0&id=bb0c9866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c9866",
  null
  
)

export default component.exports